import { render, staticRenderFns } from "./StripeBridgeMetadataEditor.vue?vue&type=template&id=57cbed6c&scoped=true"
import script from "./StripeBridgeMetadataEditor.vue?vue&type=script&lang=js"
export * from "./StripeBridgeMetadataEditor.vue?vue&type=script&lang=js"
import style0 from "./StripeBridgeMetadataEditor.vue?vue&type=style&index=0&id=57cbed6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cbed6c",
  null
  
)

export default component.exports